import { useEffect } from 'react';

export const usePreventScrollNavigation = () => {
  useEffect(() => {
    // prevent history navigation on mac using gestures
    document.body.style.overscrollBehavior = 'none';

    return () => {
      document.body.style.overscrollBehavior = 'auto';
    }
  }, []);
};
